export default "__VITE_ASSET__m1bhDSkZ__"